package one.healthium.login.navigation.magic_link

import androidx.lifecycle.ViewModelStoreOwner
import com.arkivanov.decompose.ComponentContext
import one.healthium.decompose.viewModelStoreOwner

class DefaultMagicLinkComponent(
    componentContext: ComponentContext,
    override val email: String?,
    private val onBackClicked: () -> Unit
) : MagicLinkComponent, ComponentContext by componentContext, ViewModelStoreOwner by componentContext.viewModelStoreOwner() {
    override fun onBackClicked() {
        onBackClicked.invoke()
    }
}